import { flashSuccess } from '/app/app/assets/js/utils/flash.js'
import { jsonRequest } from '/app/app/assets/js/utils/request.js'

export default (path, active) => ({
  active,

  toggle() {
    jsonRequest(path, 'PUT').then(({ message }) => {
      flashSuccess(message)
      this.active = !this.active
    })
  },
})
